export default __webpack_public_path__ + "static/zpevnik-08219f43f0138f72ca1637af1d346f67.svg";